import React from "react";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-stone-200 bg-stone-50"
    >
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3" translate="no">
              <img src="/logo-sad.svg?v=14" alt="Logo SAD" className="h-12 w-auto object-contain" />
              <span
                className="text-[11px] font-medium uppercase tracking-[0.18em] text-stone-600"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Solutions Agencement Décoration
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-stone-600">
              Courtier en agencement à l'Île de la Réunion. Je conçois et fais
              fabriquer tout agencement selon vos besoins et votre budget.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="mb-5 text-xs uppercase tracking-[0.22em] text-stone-500">
              Contact
            </p>
            <ul className="space-y-3 text-sm text-stone-700">
              <li>
                <a
                  data-testid="footer-email"
                  href="mailto:contact@sad-reunion.re"
                  className="inline-flex items-center gap-3 hover:text-orange-800"
                >
                  <Mail className="h-4 w-4 text-stone-400" strokeWidth={1.5} />
                  contact@sad-reunion.re
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone"
                  href="tel:+262692714505"
                  className="inline-flex items-center gap-3 hover:text-orange-800"
                >
                  <Phone className="h-4 w-4 text-stone-400" strokeWidth={1.5} />
                  +262 692 71 45 05
                </a>
              </li>
              <li className="inline-flex items-center gap-3">
                <MapPin className="h-4 w-4 text-stone-400" strokeWidth={1.5} />
                Saint-Paul, Île de la Réunion (974)
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="mb-5 text-xs uppercase tracking-[0.22em] text-stone-500">
              Liens
            </p>
            <ul className="space-y-2 text-sm text-stone-700">
              <li><a className="hover:text-orange-800" href="#services" onClick={scrollToId("services")}>Services</a></li>
              <li><a className="hover:text-orange-800" href="#process" onClick={scrollToId("process")}>Processus</a></li>
              <li><a className="hover:text-orange-800" href="#realisations" onClick={scrollToId("realisations")}>Réalisations</a></li>
              <li><a className="hover:text-orange-800" href="#devis" onClick={scrollToId("devis")}>Demander un devis</a></li>
              <li>
                <Link to="/admin" data-testid="footer-admin-link" className="text-stone-400 hover:text-orange-800">
                  Espace admin
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-stone-200 pt-6 text-xs text-stone-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} <span translate="no">SAD</span> — Solutions Agencement Décoration. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <Link to="/confidentialite" data-testid="footer-privacy-link" className="hover:text-orange-800">
              Confidentialité &amp; cookies
            </Link>
            <span aria-hidden="true">·</span>
            <p>Conçu avec soin · La Réunion 974</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
